<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Transaction</h6>
            </div>
            <div v-if="showVideo === true">
<!--              <ValidationObserver ref="transactionUpdateForm" id="transactionUpdateForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">-->
<!--                <b-tabs content-class="mt-3">-->
<!--                  <ValidationProvider rules="" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="external_code" class="form-label">External Code:</label>-->
<!--                    <input id="external_code" class="form-control" name="external_code" :disabled="isEdit" v-model="formData.external_code" placeholder="external code" :class="classes" type="text">-->
<!--                  </ValidationProvider>-->
<!--                </b-tabs>-->
<!--                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>-->
<!--              </ValidationObserver>-->

              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="email_id" class="form-label">Email:</label>
                    <input id="email_id" class="form-control" name="email_id" v-model="formData.user.email" :disabled="isEdit" placeholder="Currency" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="name_id" class="form-label">User First Name:</label>
                    <input id="name_id" class="form-control" name="name_id" v-model="formData.user.first_name" :disabled="isEdit" placeholder="Currency" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="currency_id" class="form-label">Currency:</label>
                    <input id="currency_id" class="form-control" name="currency_id" v-model="formData.currency.name_l.en" :disabled="isEdit" placeholder="Currency" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="balance_id" class="form-label">Balance:</label>
                    <input id="balance_id" class="form-control" name="balance_id" v-model="formData.user_balance" :disabled="isEdit" placeholder="Balance" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="amount_id" class="form-label">Amount:</label>
                    <input id="amount_id" class="form-control" name="amount_id" v-model="formData.amount" :disabled="isEdit" placeholder="Amount" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="paymentway_id" class="form-label">Payment Way:</label>
                    <input id="paymentway_id" class="form-control" name="paymentway_id" v-model="formData.paymentWay.title" :disabled="isEdit" placeholder="Payment Way" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="paid_at" class="form-label">Paid at</label>
                    <input id="paid_at" class="form-control" name="paid_at" v-model="formData.paid_at" :class="checkValidation(classes)" type="datetime-local">
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
const page = 'transaction'
export default {
  name: 'TransactionAdd',
  data () {
    return {
      page: page,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      data: '',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1
        },
        monthBeforeYear: false
      },
      formData: {
        paid_at: moment()
      },
      isCreate: false,
      currencies: [],
      users: [],
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.getCreateData().then((res) => {
      this.currencies = res.currencies
      this.users = res.users
    })
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
        if (this.formData.paid_at) {
          this.formData.paid_at = moment(this.formData.paid_at).format('YYYY-MM-DD hh:mm')
        }
      })
    }
  },
  methods: {
    ...mapActions({
      getAllCurrency: 'currency/getAllCurrency',
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          console.log(success)
          this.buttonDisable = true
          if (this.formData.paid_at) {
            this.formData.paid_at = moment(this.formData.paid_at).format('YYYY-MM-DD hh:mm')
          }
          this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
            this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
            this.$router.push('/transaction')
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          }).finally(() => {
            this.buttonDisable = false
          })
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
